import { render } from "./base-flash.vue?vue&type=template&id=036b3d4a"
import script from "./base-flash.vue?vue&type=script&lang=js"
export * from "./base-flash.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__